//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { getDomainFromUrl } from '@utils/urlUtils';

(function() {
  angular.module('curalate').component('universalImageActionsProductizeGridItem', {
    bindings: {
      product: '<',
      index: '<',
      productSelectCallback: '&',
      resultsType: '<',
    },
    template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize-grid-item.html'),
    controller: [
      '$timeout',
      'SessionVarsService',
      'TrackingService',
      'UniversalImageActionsHelpers',
      'UniversalImageActionsService',
      'PRODUCT_RESULTS_TYPES',
      function(
                $timeout,
                SessionVarsService,
                TrackingService,
                UniversalImageActionsHelpers,
                UniversalImageActionsService,
                PRODUCT_RESULTS_TYPES,
            ) {
        const self = this;
        const TRACKING_CATEGORY = UniversalImageActionsHelpers.getTrackingCategory(UniversalImageActionsService.getCurrentPage());

        self.isShareV2VendorClient = SessionVarsService.isShareV2VendorClient();

        self.productPreviewUrl = getDomainFromUrl(self.product.destinationUrl);

        self.productClicked = function() {
          if (self.resultsType === PRODUCT_RESULTS_TYPES.CATALOG_SUGGESTIONS) {
            TrackingService.recordEvent(TRACKING_CATEGORY, TrackingService.ACTION_SELECT_PRODUCT_SUGGESTION, self.index.toString());
          }
          self.productSelectCallback({ product: self.product });
        };

        self.$onInit = function() {
          $timeout(() => {
            self.initializeElement = true;
          }, Math.min(self.index * 100, 300));
        };
      },
    ],
  });
})();
